// Country dial codes used by the wizard phone field
export const COUNTRY_CODES = [
  { code: "+52", country: "Mexico" },
  { code: "+1", country: "United States / Canada" },
  { code: "+34", country: "Spain" },
  { code: "+44", country: "United Kingdom" },
  { code: "+33", country: "France" },
  { code: "+49", country: "Germany" },
  { code: "+55", country: "Brazil" },
  { code: "+57", country: "Colombia" },
  { code: "+54", country: "Argentina" },
  { code: "+56", country: "Chile" },
  { code: "+51", country: "Peru" }
];
